import { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import AverageDowntimeByRigFilters from "./averageDowntimeByRigFilters";
import AverageDowntimeByRigBody from './averageDowntimeByRigBody';
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Average downtime by rig component
 * @returns {JSX.Element}
 * @constructor
 */

const AverageDowntimeByRig = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        date: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Average Downtime By Rig" parent="Downtime"/>
            <div className="s-downtime-report">
                <AverageDowntimeByRigFilters {...{data, setData, setFilters}} />
                <AverageDowntimeByRigBody {...{filters, data}} />
            </div>
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
  );
}

export default AverageDowntimeByRig;
